<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>商户列表</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-button @click="add" type="primary"
      icon="el-icon-plus">添加商户</el-button>
      </div>
      <merchant-list @refresh="getList" @reAdd="doAdd"></merchant-list>
    </el-card>
  </div>
</template>

<script>
import './store';
import { mapActions, mapState, mapGetters, mapMutations } from 'vuex';
import MerchantList from './components/list';
import moment from 'moment';
export default {
  name: 'Merchant',
  data() {
    return {};
  },
  components: {
    MerchantList
  },
  computed: {
    ...mapState('merchant', ['pagination'])
  },
  methods: {
    ...mapActions('merchant', ['reqMerchantList', 'addMerchant']),
    add() {
      this.$prompt('请输入用户ID', '添加商户', {
        inputPlaceholder: '用户ID'
      }).then(({ value }) => {
        this.doAdd(value);
      });
    },
    doAdd(value) {
      this.$confirm(`确定将用户${value}添加为商户?`, '提示', {
          type: 'warning'
        }).then(() => {
          this.addMerchant(value).then(() => {
            this.$message({
              type: 'success',
              message: '操作成功！'
            });
            this.getList();
          });
        });
    },
    getList(data = {}) {
      this.reqMerchantList({
        ...this.pagination,
        ...data
      });
    }
  },
  created() {
    this.getList();
  }
};
</script>
